import React, { useContext, useEffect, useState } from 'react';
import clsx from 'clsx';

import { TabsContext } from './TabsContext';
import styles from './tab-panel.module.css';

export type TabPanelProps = {
  children?: React.ReactElement;
  index: number;
  tabId: string,
  panelId: string,
  className?: string
}

export const TabPanel = ({ children, index, tabId, panelId, className, ...props }: TabPanelProps) => {
  const {isActive, panelProps} = useTabPanel(index, panelId, tabId)

  return (
    <div
      className={clsx(styles.panel, className)}
      hidden={!isActive}
      {...panelProps}
      {...props}
    >
      {children}
    </div>
  );
}

export const useTabPanel = (index: number, panelId: string, tabId: string) => {
  const {currentIndex} = useContext(TabsContext)
  const [isActive, setIsActive] = useState(currentIndex == index)

  useEffect(() => {
    setIsActive(currentIndex == index)
  }, [currentIndex ,index])

  return {
    isActive: isActive,
    panelProps: {
      role: 'tabpanel',
      id: `${panelId}-${index}`,
      'aria-labelledby': `${tabId}-${index}`,
      tabIndex: 0
    }
  }
}